export const raiseUnderscore = (str: string): string => {
  if (!str) {
    return str;
  }
  return str.replace(/[_\s]+/g, '-');
};

export const normalizeKey = (value: string): string => {
  if (!value) {
    return value;
  }
  return value
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '');
};

export const pluralizeWord = (count: number, singular: string, plural = `${singular}s`): string =>
  count === 1 ? singular : plural;

export const formatCountWithUnit = (count: number, singular: string, plural = `${singular}s`): string =>
  `${count} ${pluralizeWord(count, singular, plural)}`;

export const joinWithAnd = (values: string[]): string =>
  values.length > 1 ? `${values.slice(0, -1).join(', ')} and ${values[values.length - 1]}` : (values[0] ?? '');
